/* Resolves with the SW registration once registered, or null on failure */
let _resolve;
export const swRegistrationPromise = new Promise(res => { _resolve = res; });

export function register() {
  if (!('serviceWorker' in navigator)) {
    _resolve(null);
    return;
  }

  window.addEventListener('load', async () => {
    /* Remove any old firebase-messaging-sw.js that may conflict */
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        if (reg.active?.scriptURL?.includes('firebase-messaging-sw.js')) {
          await reg.unregister();
          console.log('[TinySteps] Removed stale firebase-messaging-sw.js');
        }
      }
    } catch { /* ignore — cleanup is best-effort */ }

    navigator.serviceWorker
      .register('/service-worker.js')
      .then(reg => {
        _resolve(reg);
        reg.onupdatefound = () => {
          const worker = reg.installing;
          if (!worker) return;
          worker.onstatechange = () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[TinySteps] New version available. Refresh to update.');
            }
          };
        };
      })
      .catch(err => {
        console.error('[TinySteps] SW registration failed:', err);
        _resolve(null);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(reg => reg.unregister())
      .catch(err => console.error(err));
  }
}
